import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './v4.css'
import { meQuery } from './api/me'
import { startSessionRenewal } from './api/session'
import { startPushNotifications } from './push/pushNotifications'
import { makeRouter, queryClient } from './router'
import { installCellDropdowns } from './ui/cellDropdowns'
import { installTooltips } from './ui/tooltips'
import { installSpaLinks } from './ui/spaLinks'
import { isSessionlessPage } from './ui/barePages'

const router = makeRouter()
installTooltips()
installCellDropdowns()
installSpaLinks((href) => void router.navigate({ href }))

/* Cookie-ul de sesiune tine 30 de minute si nimeni nu-l mai rescria: portalul
   vechi o facea la fiecare pagina, iar aici pagina se incarca o singura data.
   Ceasul de aici il rescrie cat timp omul chiar lucreaza - vezi api/session.ts.

   Pe afisajul de perete NU porneste: acolo nu exista sesiune de tinut vie -
   cheia e adresa - iar ceasul ar cere un jeton nou la fiecare atingere a
   ecranului, luni la rand, de la un cap care oricum raspunde 401. */
if (!isSessionlessPage(window.location.pathname)) {
  startSessionRenewal()

  /* Notificarile push din browser, ca `firebase.min.js` din subsolul
     portalului: banda de permisiuni, jetonul FCM, toasturile. Semnul de login
     vine din `/me`; fara el (jeton vechi), banda apare ca inainte. */
  queryClient
    .fetchQuery(meQuery)
    .then((me) => startPushNotifications(me.authTime > 0 ? String(me.authTime) : ''))
    .catch(() => {
      /* Fara sesiune nu e nimeni de notificat; client.ts il trimite la intrare. */
    })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
